// extracted by mini-css-extract-plugin
module.exports = {"warning":"BalanceNegativeBox_warning__29qvR","link":"BalanceNegativeBox_link__JyJf7"};